// Защита изображений корзины от PPLR + применение Preview (финальная версия v5)
(function() {
    'use strict';
    
    console.log('🛡️ Cart Image Protection v5: Starting...');
    
    const frozenImages = new Map();

    const MASK_PROPERTY_NAMES = [
    'Druckvorlage hochladen',
    'Upload print template',
    'Upload drukvoorbeeld',
    'Subir plantilla de impresión',
    'Upload printskabelon'
    ];
    
    // Нормализация URL
    function normalizeUrl(url) {
        if (!url || url === 'undefined' || url === window.location.href) return '';
        
        return url
            .replace(/^\/\//, 'https://')
            .replace(/_\d+x\.(jpg|jpeg|png|gif|webp)/i, '.$1')
            .replace(/_1x\.(jpg|jpeg|png|gif|webp)/i, '.$1')
            .split('?')[0];
    }
    
    // Проверка: это то же изображение?
    function isSameImage(url1, url2) {
        const norm1 = normalizeUrl(url1);
        const norm2 = normalizeUrl(url2);
        
        if (!norm1 || !norm2) return false;
        
        return norm1 === norm2;
    }
    
    // Извлечь URL из HTML ссылки
    function extractUrlFromHtml(html) {
        if (!html || typeof html !== 'string') return html;
        
        // Проверяем есть ли HTML
        if (html.indexOf('<a') === -1 || html.indexOf('href=') === -1) {
            return html;
        }
        
        try {
            var tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            var link = tempDiv.querySelector('a[href]');
            if (link && link.getAttribute('href')) {
                return link.getAttribute('href');
            }
        } catch (e) {
            console.error('Error extracting URL:', e);
        }
        
        return html;
    }
    
    // Применить Preview для конфигураторов
    function applyPreviewImages() {
        const rows = document.querySelectorAll('.item-row, .pplr_cart_row, [data_pplr_row]');
        
        let appliedCount = 0;
        
        rows.forEach(row => {
            const rowIndex = Array.from(row.parentNode.children).indexOf(row);
            
            // Находим изображение
            const img = row.querySelector('img');
            if (!img) return;
            
            // Пропускаем уже обработанные
            if (img.dataset.kbPreviewApplied) return;
            
            // Ищем Preview URL в properties
            const itemDetails = row.querySelector('.item-details');
            if (!itemDetails) return;
            
            const propertyItems = itemDetails.querySelectorAll('.property-item');
            
            for (const item of propertyItems) {
                const propertyName = item.querySelector('.property-name');
                if (!propertyName) continue;
                
                const nameText = propertyName.textContent.trim().replace(':', '');
                
                if (nameText === 'Preview') {
                    // Ищем ссылку с полным URL
                    const link = item.querySelector('a[href^="http"]');
                    if (!link || !link.getAttribute('href')) continue;
                    
                    let previewUrl = link.getAttribute('href');
                    
                    // Извлекаем URL если это вложенная ссылка с 🔍
                    previewUrl = extractUrlFromHtml(previewUrl);
                    
                    if (!previewUrl || previewUrl === '🔍') {
                        console.warn(`[${rowIndex}] Invalid preview URL`);
                        continue;
                    }
                    
                    // Применяем Preview
                    //console.log(`🎨 [${rowIndex}] Applying Preview:`, previewUrl.split('/').pop());
                    img.src = previewUrl;
                    img.removeAttribute('srcset');
                    img.removeAttribute('data-srcset');
                    img.dataset.kbPreviewApplied = 'true';
                    
                    appliedCount++;
                    break;
                }
            }
        });
        
        if (appliedCount > 0) {
            //console.log(`✅ Applied ${appliedCount} Preview images`);
        }
    }
    
    // Очистить srcset="undefined"
    function cleanUndefinedSrcset() {
        const images = document.querySelectorAll('img[srcset="undefined"], img[data-srcset="undefined"], img[src="undefined"]');
        
        let cleanedCount = 0;
        images.forEach(img => {
            if (img.getAttribute('srcset') === 'undefined') {
                img.removeAttribute('srcset');
                cleanedCount++;
            }
            if (img.getAttribute('data-srcset') === 'undefined') {
                img.removeAttribute('data-srcset');
                cleanedCount++;
            }
            if (img.getAttribute('src') === 'undefined') {
                // Попробуем найти Preview для этого изображения
                const row = img.closest('.item-row, .pplr_cart_row, [data_pplr_row]');
                if (row) {
                    const link = row.querySelector('.property-item a[href^="http"]');
                    if (link) {
                        let previewUrl = extractUrlFromHtml(link.getAttribute('href'));
                        if (previewUrl && previewUrl !== '🔍') {
                            img.src = previewUrl;
                            console.log('🔧 Fixed undefined src');
                        }
                    }
                }
                cleanedCount++;
            }
        });
        
        if (cleanedCount > 0) {
            console.log(`🧹 Cleaned ${cleanedCount} undefined attributes`);
        }
    }
    
    // Заморозить изображение
    function freezeImage(img) {
        if (img.dataset.kbFrozen) return;
        
        if (!img.complete || !img.src || img.src === window.location.href || img.src === 'undefined') {
            return;
        }
        
        const normalizedSrc = normalizeUrl(img.src);
        
        if (!normalizedSrc) {
            return;
        }
        
        const row = img.closest('.item-row, .pplr_cart_row, [data_pplr_row]');
        if (!row) return;
        
        const rowIndex = Array.from(row.parentNode.children).indexOf(row);
        
        //console.log(`🧊 [${rowIndex}] Freezing:`, normalizedSrc.split('/').pop());
        
        frozenImages.set(img, normalizedSrc);
        
        // ✅ НОВОЕ: Запоминаем product-id для дополнительной проверки
        const productId = row.getAttribute('data-product-id') || '';
        img.dataset.kbProductId = productId;
        
        // Блокируем setAttribute('src', ...)
        const originalSetAttribute = img.setAttribute.bind(img);
        img.setAttribute = function(name, value) {
            if (name === 'src') {
                // ✅ Проверяем: это тот же product-id?
                const currentRow = img.closest('.item-row, .pplr_cart_row, [data_pplr_row]');
                const currentProductId = currentRow ? currentRow.getAttribute('data-product-id') : '';
                
                if (currentProductId && img.dataset.kbProductId !== currentProductId) {
                    console.log(`🛡️ [${rowIndex}] BLOCKED setAttribute (wrong product-id):`);
                    console.log('  Expected product-id:', img.dataset.kbProductId);
                    console.log('  Current product-id:', currentProductId);
                    return;
                }
                
                if (isSameImage(value, normalizedSrc)) {
                    return originalSetAttribute(name, value);
                }
                
                console.log(`🛡️ [${rowIndex}] BLOCKED setAttribute (different image):`);
                console.log('  Frozen:', normalizedSrc.split('/').pop());
                console.log('  Blocked:', normalizeUrl(value).split('/').pop());
                return;
            }
            
            return originalSetAttribute(name, value);
        };
        
        // Блокируем img.src = ...
        const descriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
        Object.defineProperty(img, 'src', {
            get: function() {
                return descriptor.get.call(this);
            },
            set: function(newValue) {
                if (!newValue || newValue === 'undefined') {
                    console.log(`🛡️ [${rowIndex}] BLOCKED undefined src`);
                    return;
                }
                
                // ✅ Проверяем product-id
                const currentRow = this.closest('.item-row, .pplr_cart_row, [data_pplr_row]');
                const currentProductId = currentRow ? currentRow.getAttribute('data-product-id') : '';
                
                if (currentProductId && this.dataset.kbProductId !== currentProductId) {
                    console.log(`🛡️ [${rowIndex}] BLOCKED img.src (wrong product-id):`);
                    console.log('  Expected product-id:', this.dataset.kbProductId);
                    console.log('  Current product-id:', currentProductId);
                    return;
                }
                
                if (isSameImage(newValue, normalizedSrc)) {
                    descriptor.set.call(this, newValue);
                    return;
                }
                
                console.log(`🛡️ [${rowIndex}] BLOCKED img.src (different image):`);
                console.log('  Frozen:', normalizedSrc.split('/').pop());
                console.log('  Blocked:', normalizeUrl(newValue).split('/').pop());
            },
            configurable: true
        });
        
        img.dataset.kbFrozen = 'true';
    }
    function restoreCorrectPreviews() {
        const rows = document.querySelectorAll('.item-row, .pplr_cart_row, [data_pplr_row]');
        
        rows.forEach(row => {
            const img = row.querySelector('img');
            if (!img || !img.dataset.kbPreviewApplied) return;
            
            // Находим правильный Preview в properties
            const itemDetails = row.querySelector('.item-details');
            if (!itemDetails) return;
            
            const propertyItems = itemDetails.querySelectorAll('.property-item');
            
            for (const item of propertyItems) {
                const propertyName = item.querySelector('.property-name');
                if (!propertyName) continue;
                
                const nameText = propertyName.textContent.trim().replace(':', '');
                
                if (nameText === 'Preview') {
                    const link = item.querySelector('a[href^="http"]');
                    if (!link || !link.getAttribute('href')) continue;
                    
                    let correctPreview = extractUrlFromHtml(link.getAttribute('href'));
                    
                    if (!correctPreview || correctPreview === '🔍') continue;
                    
                    // Нормализуем оба URL для сравнения
                    const currentNormalized = normalizeUrl(img.src);
                    const correctNormalized = normalizeUrl(correctPreview);
                    
                    // Если изображение НЕ правильное - восстанавливаем!
                    if (currentNormalized !== correctNormalized) {
                        const rowIndex = Array.from(row.parentNode.children).indexOf(row);
                        //console.log(`🔄 [${rowIndex}] RESTORING correct Preview:`);
                        //console.log('  Wrong:', currentNormalized.split('/').pop());
                        //console.log('  Correct:', correctNormalized.split('/').pop());
                        
                        // Временно снимаем защиту
                        const wasFrozen = img.dataset.kbFrozen;
                        delete img.dataset.kbFrozen;
                        
                        // Применяем правильный Preview
                        img.src = correctPreview;
                        img.removeAttribute('srcset');
                        img.removeAttribute('data-srcset');
                        
                        // Возвращаем защиту
                        if (wasFrozen) {
                            img.dataset.kbFrozen = wasFrozen;
                            frozenImages.set(img, correctNormalized);
                        }
                    }
                    
                    break;
                }
            }
        });
    }
    function maskTemplateUrls() {
        const rows = document.querySelectorAll('.item-row, .pplr_cart_row, [data_pplr_row]');
        rows.forEach(row => {
            const propertyItems = row.querySelectorAll('.property-item');
            propertyItems.forEach(item => {
            const nameEl = item.querySelector('.property-name');
            const valEl  = item.querySelector('.property-value');
            if (!nameEl || !valEl) return;
            const name = nameEl.textContent.trim().replace(':', '');
            if (!MASK_PROPERTY_NAMES.includes(name)) return;
            const val = valEl.textContent.trim();
            if (!val.startsWith('http')) return;
            if (valEl.dataset.kbMasked) return;
            valEl.innerHTML = `<a href="${val}" target="_blank" rel="noopener">🔍</a>`;
            valEl.dataset.kbMasked = 'true';
            });
        });
    }
    // Обработать все изображения
    function protectAllImages() {
        const images = document.querySelectorAll('.item-row img, .pplr_cart_row img, [data_pplr_row] img');
        
        let frozenCount = 0;
        images.forEach(img => {
            if (!img.dataset.kbFrozen) {
                freezeImage(img);
                if (img.dataset.kbFrozen) frozenCount++;
            }
        });
        
        if (frozenCount > 0) {
            //console.log(`✅ Frozen ${frozenCount} images`);
        }
    }
    
    // Инициализация
    function init() {
        //console.log('🛡️ Initializing protection...');
        
        setTimeout(() => {
            applyPreviewImages();
            cleanUndefinedSrcset();
            protectAllImages();
            restoreCorrectPreviews(); // ← ДОБАВЛЕНО
            maskTemplateUrls();
        }, 1000);
        
        let attempts = 0;
        const maxAttempts = 20;
        
        const interval = setInterval(() => {
            applyPreviewImages();
            cleanUndefinedSrcset();
            protectAllImages();
            restoreCorrectPreviews(); // ← ДОБАВЛЕНО
            maskTemplateUrls();
            attempts++;
            
            if (attempts >= maxAttempts) {
                clearInterval(interval);
                console.log('✅ Protection initialized');
                
                // Постоянный мониторинг
                setInterval(() => {
                    applyPreviewImages();
                    cleanUndefinedSrcset();
                    protectAllImages();
                    restoreCorrectPreviews(); // ← ДОБАВЛЕНО
                    maskTemplateUrls();
                }, 1000);
            }
        }, 500);
    }
        
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
    
    const observer = new MutationObserver(() => {
        applyPreviewImages();
        cleanUndefinedSrcset();
        protectAllImages();
        restoreCorrectPreviews();
        maskTemplateUrls();
    });
    
    const target = document.querySelector('#cart-main') || document.body;
    if (target) {
        observer.observe(target, {
            childList: true,
            subtree: true
        });
    }
})();